import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { css } from '@emotion/react';
export { shortcutStyle } from '@atlaskit/editor-shared-styles/shortcut';
export { scrollbarStyles } from '@atlaskit/editor-shared-styles/scrollbar';
export var expandIconWrapperStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: -8px;\n"])));
export var clickSelectWrapperStyle = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  user-select: all;\n"])));